import { HOST_API } from 'src/config-global';
import { type OptionsMap } from 'src/types';

type PimcoreOptionItem = {
  value: string;
  label: string;
};

type PimcoreOptionsResponse = {
  list?: PimcoreOptionItem[];
};

export async function fetchPimcoreOptionsMap(uri: string, params?: string[]): Promise<OptionsMap> {
  let url = `${HOST_API}${uri}`;

  params?.forEach((param) => {
    url += `/${param}`;
  });

  const response = await fetch(url);
  const responseJson: PimcoreOptionsResponse = await response.json();

  const optionsMap: OptionsMap = {};

  responseJson.list?.forEach((element) => {
    optionsMap[element.value] = element.label;
  });

  return optionsMap;
}

